import {
  GroupManagementFormI,
  ValidationSet
} from '../../../../types/interface';
import { commonValidations } from '../validations';

export const GroupManagementSet: ValidationSet<GroupManagementFormI> = {
  group_slug: [],
  group_name_en: commonValidations.group_management_level_name,
  group_name_de: commonValidations.group_management_level_name_de,
  admin_level: commonValidations.admin_level,
  federal_state: commonValidations.level_order_valid,
  is_active: [],
  is_verified: []
};
